import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isOdd',
})
export class IsOddPipe implements PipeTransform {
  transform(value: number): boolean {
    return !!(value % 2);
  }
}
